<pdq-rules-dynamic-form
  [formGroup]="formGroup"
  [formArrayFieldName]="formArrayFieldName"
  [rules]="restrictionsRules | addCurrencyOption: shopCurrencySymbol"
  [entities]="entities"
  [shopCurrencySymbol]="shopCurrencySymbol"
  [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
